import { signOut } from 'aws-amplify/auth';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';

type Props = {
  /** ダイアログの開閉状態。 */
  open: boolean;
  /** ダイアログを閉じる関数。 */
  onClose: VoidFunction;
};

/** ログアウトダイアログのコンポーネント。 */
export const Dialog = ({ open, onClose: handleClose }: Props) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const handleClickSignOutButton = async () => {
    try {
      queryClient.clear();
      await signOut();
      handleClose();
      navigate('/');
    } catch (error) {
      // エラー処理
    }
  };
  return open ? (
    <>
      <div className="fixed inset-0 bg-textPrimary bg-opacity-45 z-10" />
      <div className="bg-surface rounded-[28px] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[400px] p-[32px] absolute z-20">
        <div className="flex flex-col gap-[40px]">
          <div className="flex flex-col gap-[16px]">
            <h1 className="text-[20px] text-textPrimary noto-sans-jp-bold">
              ログアウト
            </h1>
            <p className="text-[14px] text-textSecondary noto-sans-jp-medium">
              ログアウトします。よろしいですか？
            </p>
          </div>
          <div className="flex justify-end gap-[32px]">
            <button
              className="text-[18px] text-textSecondary noto-sans-jp-bold"
              onClick={handleClose}
            >
              キャンセル
            </button>
            <button
              className="text-[18px] text-error noto-sans-jp-bold"
              onClick={handleClickSignOutButton}
            >
              ログアウト
            </button>
          </div>
        </div>
      </div>
    </>
  ) : (
    <></>
  );
};
